<template>
  <b-row class="mt-4" v-if="$store.getters.appDeviceType != 'Phone'">
    <b-col md="6" class="mb-3">
      <b-card class="formCardDash">
        <div class="card-body">
          <h6 class="card-title">Lead Conversion Trend</h6>
          <apexchart
            type="line"
            height="350"
            :options="lineChartOptions"
            :series="lineChartSeries"
          ></apexchart>
        </div>
      </b-card>
    </b-col>
    <b-col md="6" class="mb-3">
      <b-card class="formCardDash">
        <div class="card-body">
          <h6 class="card-title">Revenue by Month</h6>
          <apexchart
            type="bar"
            height="350"
            :options="barChartOptions"
            :series="barChartSeries"
          ></apexchart>
        </div>
      </b-card>
    </b-col>
    <b-col md="6" class="mb-3">
      <b-card class="formCardDash">
        <div class="card-body">
          <h6 class="card-title">Lead Status Distribution</h6>
          <apexchart
            type="pie"
            height="350"
            :options="pieChartOptions"
            :series="pieChartSeries"
          ></apexchart>
        </div>
      </b-card>
    </b-col>
    <b-col md="6" class="mb-3">
      <b-card class="formCardDash">
        <div class="card-body">
          <h6 class="card-title">Performance by Client</h6>
          <apexchart
            type="donut"
            height="350"
            :options="donutChartOptions"
            :series="donutChartSeries"
          ></apexchart>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "ChartsSection",
  props: {
    lineChartOptions: {
      type: Object,
      required: true,
    },
    lineChartSeries: {
      type: Array,
      required: true,
    },
    barChartOptions: {
      type: Object,
      required: true,
    },
    barChartSeries: {
      type: Array,
      required: true,
    },
    pieChartOptions: {
      type: Object,
      required: true,
    },
    pieChartSeries: {
      type: Array,
      required: true,
    },
    donutChartOptions: {
      type: Object,
      required: true,
    },
    donutChartSeries: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.formCardDash {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.card-title {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// ChartsSection.vue?fa6d0dcc